import { render, staticRenderFns } from "./WalletPage.vue?vue&type=template&id=5ed8aa77&scoped=true"
import script from "./WalletPage.vue?vue&type=script&lang=js"
export * from "./WalletPage.vue?vue&type=script&lang=js"
import style0 from "./WalletPage.vue?vue&type=style&index=0&id=5ed8aa77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed8aa77",
  null
  
)

export default component.exports